import Vue from 'vue'

import fr from './fr.json'
import us from './us.json'

export const sports = function () {
  if (Vue.prototype.$country === 'FR') {
    return fr
  } else {
    return us
  }
}



// WEBPACK FOOTER //
// ./src/assets/sports/index.js